// components太多了，目前很多都不是公共的，需要用到的自己加，另外也要看看都放进来对打包体积有没有影响
import {
    DocRecommendFoldSvg,
    DocRecommendDownSvg,
    DocRecommendHelpSvg,
    DocumentSvg,
    DocReferenceFillSvg,
    RecommendReadingCloseSvg,
    ThumbsUpSvg,
    ThumbsDownSvg,
} from '@/icons';

import * as Icon from '@/components/Icon';
import * as Loading from '@/components/Loading';
import * as Tooltip from '@/components/Tooltip'; // 存在export default的，会作为default属性导出

import * as toast from '@/components/Toast';
import * as Button from '@/components/Button';

export default {
    // icons组件，按需引入
    icons: {
        DocRecommendFoldSvg,
        DocRecommendDownSvg,
        DocRecommendHelpSvg,
        DocumentSvg,
        DocReferenceFillSvg,
        RecommendReadingCloseSvg,
        ThumbsUpSvg,
        ThumbsDownSvg,
    },
    // 公共组件，项目的src/components路径下,按需引入
    common: {
        Loading,
        Icon,
        Tooltip,
        toast,
        Button,
    },
};
